import React from "react";
import { useTranslation } from "react-i18next";

import { Team, Tournament } from "@gp/models";
import TeamIcon from "@components/icons/TeamIcon";
import { RecentForm } from "@data-types/sport-stats/SportStatsTypes";
import { EventWinLostDrawStats } from ".";

export const TeamItem = ({
	tournament,
	mainTeam,
	opponentTeam,
	form,
}: {
	tournament: Tournament | undefined;
	mainTeam: Team;
	opponentTeam: Team;
	form: RecentForm[] | null;
}) => {
	const { t } = useTranslation();

	const getName = (team: Team) => {
		if (team.gender === 1) {
			return `${team.name} (${t("OFFER.GENDER.WOMEN")})`;
		}

		return team.name;
	};

	return (
		<div className="event__team">
			<TeamIcon
				showCountryFlag={tournament?.showCountryFlag}
				flagCode={mainTeam?.countryCode}
				jerseyTypeAbrv={mainTeam?.jerseyTypeAbrv}
				opponentFlagCode={opponentTeam?.countryCode}
				opponentJerseyTypeAbrv={opponentTeam?.jerseyTypeAbrv}
				className="event__team__icon u-icon--xxxlrg"
			/>
			<div className="event__team__title">{getName(mainTeam)}</div>
			<EventWinLostDrawStats form={form} />
		</div>
	);
};
